// Entry point for the ESBuild build script in package.json

// Stamp html.js synchronously, before anything else in the bundle evaluates
// (Stimulus registration included). A failed boot then degrades to the designed
// no-JS state. Harmless for all tenants — see modules/js_stamp.js.
import "./modules/js_stamp";

// Initialise client-side error reporting first, so it can capture failures
// during the rest of bundle initialisation. No-ops on dev hosts.
import { initSentry } from "./modules/sentry_browser";
initSentry();

// Import browser compatibility module first to fix older browser issues
import "./modules/browser_compatibility";

// Import Turbo first to ensure it initializes before other dependencies
import * as Turbo from "@hotwired/turbo-rails";
// Import Stimulus controllers
import "./controllers";

// Import Rails 8 compatibility layer
import "./rails8_turbo_compatibility";

// Force start Turbo
document.addEventListener("DOMContentLoaded", () => {
  if (typeof Turbo !== 'undefined') {
    console.log("Turbo imported successfully:", Turbo);

    // Ensure Turbo is globally available
    if (!window.Turbo) {
      console.log("Setting window.Turbo");
      window.Turbo = Turbo;
    }

    // Configure Turbo (now handled by rails8_turbo_compatibility.js)
  } else {
    console.error("Turbo not imported correctly!");
  }
});

// Initialize ActionCable for Turbo Streams
import "@rails/actioncable";
import "./channels";

// Rails UJS and ActiveStorage
import Rails from "@rails/ujs";
import * as ActiveStorage from "@rails/activestorage";
Rails.start();
ActiveStorage.start();
window.Rails = Rails;

// Core dependencies and modules
import { ready } from "./modules/core";
import "./modules/layout_verify";
import "./modules/panel_form_stamper";

// Preload all layout modules to avoid dynamic import MIME type issues
import * as dashboard from "./layouts/dashboard";
import * as panel from "./layouts/panel";
import * as sys from "./layouts/sys";
import * as site from "./layouts/site";

// The application will detect which layout is being used and load the appropriate JavaScript
ready(() => {
  console.log("DOM ready - initializing application");

  // Determine which layout is being used based on body data attribute or class
  const body = document.querySelector("body");

  // Using a try/catch to handle any module loading errors
  try {
    // Store all layout modules in an object for easy access
    const layouts = {
      dashboard: dashboard,
      panel: panel,
      sys: sys,
      site: site
    };

    // Determine which layout to initialize
    let layoutName = 'site'; // default

    if (body.classList.contains("layout-dashboard") || body.dataset.layout === "dashboard") {
      layoutName = 'dashboard';
    } else if (body.classList.contains("layout-panel") || body.dataset.layout === "panel") {
      layoutName = 'panel';
    } else if (body.classList.contains("layout-sys") || body.dataset.layout === "sys") {
      layoutName = 'sys';
    }

    console.log(`Initializing ${layoutName} layout module`);

    // Initialize the appropriate layout module
    if (layouts[layoutName] && typeof layouts[layoutName].initialize === 'function') {
      layouts[layoutName].initialize();
      console.log(`${layoutName} layout module initialized successfully`);
    } else {
      console.warn(`${layoutName} layout module does not have an initialize function`);
    }

  } catch (e) {
    console.error("Error initializing application:", e);
  }
});